import { FC, useMemo, useState } from 'react'
import { Button, Tooltip } from 'antd'
import { Path } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'
import { getPickingTask, getStepOfType, StepState, StepTypeNames } from '../../../domain/task'
import MultistopModal from '../multistop-modal.component'
import { JobState, Job } from '../../../domain/job'

interface ButtonOpenMultistopProps {
  job: Job
  setSelectedJob: (job?: Job) => void
}

const ButtonOpenMultistop: FC<ButtonOpenMultistopProps> = ({ job, setSelectedJob }) => {
  const { operationModel, status: jobStatus, tasks } = job
  const [isModalOpen, setIsModalOpen] = useState(false)

  const { t } = useTranslation()

  const showModal = () => {
    setIsModalOpen(!isModalOpen)
  }

  const disabledCreateMultistop = useMemo(() => {
    try {
      const task = getPickingTask(operationModel, tasks)
      const checkOutStep = getStepOfType(StepTypeNames.CHECKING_OUT, task.steps)

      return checkOutStep.status === StepState.DONE
    } catch (error) {
      return true
    }
  }, [operationModel, tasks, jobStatus])

  return (
    <>
      <Tooltip title={t('multistop.title')}>
        <Button
          disabled={jobStatus === JobState.CANCELLED || jobStatus === JobState.FINISHED}
          onClick={showModal}
          icon={<Path size={30} style={{ padding: '5px' }} />}
        />
      </Tooltip>
      {isModalOpen && (
        <MultistopModal
          job={job}
          handleCancel={() => showModal()}
          diabledCreateStop={disabledCreateMultistop}
          setSelectedJob={setSelectedJob}
        />
      )}
    </>
  )
}

export default ButtonOpenMultistop
